import * as React from 'react';
import * as AppPics from 'assets/images';
import useReviewStats from 'hooks/API/GET/useReviewStats';
import CircularProgress from '@material-ui/core/CircularProgress';
import UserReviewItems from './UserReviewItems';
import { useHistory } from 'react-router-dom';

function UserReviewCounter() {
  const history = useHistory();
  const [currentTab, setCurrentTab] = React.useState('discover');

  const { isLoading, isError, data } = useReviewStats({ enabled: true });
  const { discover = {}, assess = {}, perform = {} } = data?.data || {};

  return (
    <div className="mainWraper">
      <div className="tab app-l-tab_main">
        <ul className="tab__menu">
          <li className="back" onClick={() => history.goBack()}>
            <button className="btn-back">
              <img src={AppPics.BackSvg} alt="" />
            </button>
          </li>
          <li
            className={`${currentTab === 'discover' ? 'active' : ''}`}
            onClick={() => setCurrentTab('discover')}
          >
            Discover
            <span className="menuWrap__menuIndi">
              {(discover.geeks || 0) +
                (discover.mindMaps || 0) +
                (discover.notesCount || 0) +
                (discover.stories || 0) +
                (discover.videos || 0)}
            </span>
          </li>
          <li
            className={`${currentTab === 'assess' ? 'active' : ''}`}
            onClick={() => setCurrentTab('assess')}
          >
            Assess
            <span className="menuWrap__menuIndi">
              {(assess.ncert || 0) + (assess.past_paper_quiz || 0) + (assess.qb || 0)}
            </span>
          </li>
          <li
            className={`${currentTab === 'perform' ? 'active' : ''}`}
            onClick={() => setCurrentTab('perform')}
          >
            Perform
            <span className="menuWrap__menuIndi">
              {(perform.mock || 0) + (perform.previous_year || 0)}
            </span>
          </li>
        </ul>
        <div className="tab__content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-6">
                <h2 className="prime-head p-0 boldtitle actioncentre aclist">Action Centre</h2>
              </div>
            </div>
            {isLoading ? (
              <div className="row justify-content-center">
                <CircularProgress />
              </div>
            ) : isError ? (
              <div>
                <h2 className="prime-head p-0 text-center">
                  Failed to load statistics. Please try after sometime.
                </h2>
              </div>
            ) : (
              <div className="row">
                <div className="col-12">
                  {currentTab === 'discover' && (
                    <div class="app-l-action-centre-wrapper">
                      <UserReviewItems items={discover} />
                    </div>
                  )}
                  {currentTab === 'assess' && (
                    <div class="app-l-action-centre-wrapper">
                      <UserReviewItems items={assess} />
                    </div>
                  )}
                  {currentTab === 'perform' && (
                    <div class="app-l-action-centre-wrapper">
                      <UserReviewItems items={perform} />
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserReviewCounter;
